module.exports = __webpack_public_path__ + "img/certificate-stamp.34f434c.svg";